import {
  SELECTOR_OPTIONS_GET_FAILURE,
  TREATMENT_CREATE_FAILURE,
  TREATMENT_UPDATE_FAILURE,
  TREATMENT_INSTANCE_CANCEL_FAILURE,
  TREATMENT_INSTANCE_UPDATE_FAILURE,
  TREATMENT_INSTANCE_ADD_OVERRIDE_FAILURE,
  TREATMENT_INSTANCE_REMOVE_OVERRIDE_FAILURE,
  VISIT_ACTUAL_UPDATE_FAILURE,
  CANCELLATION_REASON_CREATE_FAILURE,
  CANCELLATION_REASON_UPDATE_FAILURE,
  GENERATE_REPORT_FAILURE,
  REFERRAL_CLOSE_FAILURE,
  REFERRAL_UPDATE_FAILURE,
  REFERRAL_CREATE_FAILURE,
  ACTIVITY_UPDATE_FAILURE,
  ACTIVITY_DEACTIVATE_FAILURE,
  ACTIVITY_CREATE_FAILURE,
  ACTIVITY_ACTIVATE_FAILURE,
  TIMESLOT_SAVE_FAILURE,
  PATIENT_GET_FAILURE,
  PATIENT_ADD_FAILURE,
  PATIENT_UPDATE_FAILURE,
  SYNCHRONIZATION_DETAILS_GET_FAILURE,
  SYNCHRONIZE_FAILURE,
  SYSTEM_INFO_GET_FAILURE,
  PATIENT_EXCLUDED_CLINICIAN_REMOVE_FAILURE,
  ACTIVITY_TYPE_CREATE_FAILURE,
  ACTIVITY_TYPE_UPDATE_FAILURE,
  ACTIVITY_TYPE_GET_FAILURE,
  REFERRALS_SYNC_FAILURE,
  PATIENT_SYNC_FAILURE,
} from '../actions/constants/types';

// list of failure action types handled by the global error handler
export const globalErrorList = [
  SELECTOR_OPTIONS_GET_FAILURE,
  TREATMENT_CREATE_FAILURE,
  TREATMENT_UPDATE_FAILURE,
  TREATMENT_INSTANCE_CANCEL_FAILURE,
  TREATMENT_INSTANCE_UPDATE_FAILURE,
  TREATMENT_INSTANCE_ADD_OVERRIDE_FAILURE,
  TREATMENT_INSTANCE_REMOVE_OVERRIDE_FAILURE,
  VISIT_ACTUAL_UPDATE_FAILURE,
  CANCELLATION_REASON_CREATE_FAILURE,
  CANCELLATION_REASON_UPDATE_FAILURE,
  GENERATE_REPORT_FAILURE,
  REFERRAL_CLOSE_FAILURE,
  REFERRAL_UPDATE_FAILURE,
  REFERRAL_CREATE_FAILURE,
  ACTIVITY_UPDATE_FAILURE,
  ACTIVITY_DEACTIVATE_FAILURE,
  ACTIVITY_CREATE_FAILURE,
  ACTIVITY_ACTIVATE_FAILURE,
  TIMESLOT_SAVE_FAILURE,
  PATIENT_GET_FAILURE,
  PATIENT_ADD_FAILURE,
  PATIENT_UPDATE_FAILURE,
  SYNCHRONIZATION_DETAILS_GET_FAILURE,
  SYNCHRONIZE_FAILURE,
  SYSTEM_INFO_GET_FAILURE,
  PATIENT_EXCLUDED_CLINICIAN_REMOVE_FAILURE,
  ACTIVITY_TYPE_CREATE_FAILURE,
  ACTIVITY_TYPE_UPDATE_FAILURE,
  ACTIVITY_TYPE_GET_FAILURE,
  REFERRALS_SYNC_FAILURE,
  PATIENT_SYNC_FAILURE,
];

export const defaultConfig = {
  // How long should the message stay on screen (in ms)
  duration: 5000,
};
// Example: [ACTION_TYPE]: { duration: null } to make a specific ACTION_TYPE stay on screen
export const perErrorConfiguration = {};
